 @if(loading){<lib-spinner-overlay></lib-spinner-overlay>}
<div style="display: flex;">
    <div style="padding: 1px; min-width:150px">
        @for (todo of TodosList; track todo) {
            <mat-accordion>              
                <mat-expansion-panel>
                    <mat-expansion-panel-header class="dachClass">
                        <mat-card appearance="outlined" class="mainCard" (click)="$event.stopPropagation();objektCLicked(todo.ObjektId);">
                                <mat-card-title>
                                    <span>{{todo.Objektbezeichnung }}</span>
                                    @if(this.getObjektistErledigt(todo)){<mat-icon >check</mat-icon>}
                                </mat-card-title>
                                <mat-card-subtitle>
                                    <table>
                                        <tr>
                                            <td>{{language.Termin | translationPipe}}</td>
                                            <td>{{todo.Termin | date:"dd.MM.yyyy"}}</td>
                                        </tr>
                                    </table>
                                </mat-card-subtitle>

                        </mat-card>
                    </mat-expansion-panel-header>
                    <mat-card  appearance="outlined" class="secondCard">
                        <mat-card-content>
                            <mat-accordion>
                                @for(roofArea of roofAreaList; track roofArea.roofArea.Bezeichnung){
                                    
                                    @if(roofArea.roofArea.ObjektID == todo.ObjektId){
                                        <mat-expansion-panel [(expanded)]="roofArea.panelOpen">
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>{{roofArea.roofArea.Bezeichnung}}
                                                    @if(this.getRoofareayistErledigt(roofArea, todo)){<mat-icon >check</mat-icon>}
                                                </mat-panel-title>
                                            
                                                <mat-panel-description>{{roofArea.roofArea.Longitude}},
                                                    {{roofArea.roofArea.Latitude}}</mat-panel-description>
                                            </mat-expansion-panel-header>

                                            @for(safetyPoint of roofArea.safetyPointList; track safetyPoint.SafetyPointId){
                                            <mat-card appearance="outlined" (click)="safetypointCLicked(safetyPoint)">
                                                <mat-card-content>
                                                    <mat-list>
                                                        <mat-list-item class="safetyBez" style="display: flex;">{{safetyPoint.Bezeichnung}}                        
                                                            @if(this.getSafetypointistErledigt(safetyPoint, todo)){<mat-icon >check</mat-icon>}
                                                        </mat-list-item>
                                                        <mat-list-item>{{language.Sicherungssystem | translationPipe}}: {{safetyPoint.SicherungssystemBezeichnung}}</mat-list-item>
                                                        <mat-list-item>{{language.Longitude | translationPipe}}: {{safetyPoint.Longitude}}</mat-list-item>
                                                        <mat-list-item>{{language.Latitude | translationPipe}}: {{safetyPoint.Latitude}}</mat-list-item>
                                                    </mat-list>
                                                    <doc-documents [documentList]="getDokumentList(safetyPoint)" [disabled]="true" [maxImageAmount]="getDokumentList(safetyPoint).length"></doc-documents>
                                                </mat-card-content>
                                            </mat-card>
                                            }
                                        </mat-expansion-panel>
                                    }
                                }
                            </mat-accordion>
                        </mat-card-content>
                    </mat-card>
                </mat-expansion-panel>           
            </mat-accordion>   
        }
    </div>
    <div style="flex: 1; height: 100vh;">
        <google-map height="100%" width="100%" [center]="center" [zoom]="15" [options]="mapOptions" (mapClick)="mapClicked($event)">
                            
            @for (marker of markers; track marker) {
                
                <map-marker  [icon]="marker.icon" [position]="marker.position"
                    (mapClick)="showDetails(dialogTemplate, tableTemplate, marker.title)">
                </map-marker> 

              <ng-template #tableTemplate>
                    <mat-card>
                        <mat-card-header>                            
                        </mat-card-header>
                        <mat-card-content>
                            <div> {{language.debitor | translationPipe}}: {{marker.data.Kunde}}</div>
                            <div> {{language.objekt | translationPipe}}: {{marker.data.Objekt}}</div>
                            @if(marker.data.istSafetypoint){
                                <div> {{language.roofarea | translationPipe}}: {{marker.data.Roofarea}}</div>
                            }    
                            <div> {{language.Latitude | translationPipe}}: {{marker.data.Latitude}}</div>
                        
                            <div> {{language.Longitude | translationPipe}}: {{marker.data.Longitude}}</div>
                            @if(marker.data.istRoofArea){
                                <div> {{language.AnzahlSafetypoints | translationPipe}}: {{marker.data.AnzahlSafetypoints}}</div>
                            }

                        </mat-card-content>
                    </mat-card>
                    
              </ng-template>                
            }

        </google-map>
    </div>
    <ng-template #dialogTemplate let-data let-title="title">
    <div mat-dialog-title>
        <span>{{ data.title }}</span>
        <button color="primary" mat-dialog-close mat-icon-button style="float: right;">
        <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <ng-container [ngTemplateOutlet]="data.content"></ng-container>
    </mat-dialog-content>
    </ng-template>    
</div>

